import { cleanStyle, convertASCIIForNum, getGuid } from '../../utils';
export const quesMixin = {
  props: {
    currentComponents: {
      default: () => { return []; },
      type: Array
    },
    index: {
      type: Number
    },
    currentComponent: {
      default: () => { return {}; },
      type: Object
    }
  },
  data() {
    return {
      focusIndex: -1
    };
  },
  computed: {
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    cleanStyle,
    inputChange() {
      this.$forceUpdate();
    },
    // 生成Guid
    getGuid,
    // 生成ABCD选项Key
    convertASCII: convertASCIIForNum,
    deleteSubject(index) {
      this.currentComponents.splice(this.index, 1);
      this.$emit('deleteSubject', index);
    }
  }
};
